import React from "react";
import { createUseStyles } from "react-jss";
var useStyles = createUseStyles({
    svg: {
        fill: function (props) { return props.color; },
        width: 26,
        height: 26,
        userSelect: "none",
    }
});
export default function EditTeamIcon(_a) {
    var color = _a.color;
    var classes = useStyles({ color: color });
    return (React.createElement("svg", { viewBox: "0 0 65 66", className: classes.svg },
        React.createElement("polygon", { points: "23.3,34.51 31.96,43.01 48.2,26.92 39.85,18.12 \t\t\t" }),
        React.createElement("polygon", { points: "22.2,35.77 30.6,44.33 19.49,47.04 \t\t\t" }),
        React.createElement("path", { d: "M32.37,63.13C15.95,63.13,2.6,49.78,2.6,33.36S15.95,3.6,32.37,3.6s29.77,13.35,29.77,29.77\n\t\t\tS48.78,63.13,32.37,63.13z M32.37,9.4C19.15,9.4,8.41,20.15,8.41,33.36s10.75,23.96,23.96,23.96s23.96-10.75,23.96-23.96\n\t\t\tS45.58,9.4,32.37,9.4z" })));
}
//# sourceMappingURL=EditTeamIcon.js.map